import React, {useEffect, useState} from "react";
import {IInvoice} from "../../utils/interfaces/IInvoice";
import RestaurantsList from "./RestaurantsList";
import {PiFileCsv} from "react-icons/pi";
import {LiaFileInvoiceDollarSolid} from "react-icons/lia"
import {CSVLink} from "react-csv";
import {useAccounting} from "../../utils/contexts/accounting_context";
import {csvHeaders, invoice_csv_data} from "../../logics/csv-export";
import useApiUpdateRestaurateur from "./api-hooks/useApiUpdateRestaurateur";
import {CustomAxiosError} from "../../logics/api-config";
import {useQueryClient} from "react-query";
import {useToast} from "../../utils/contexts/toast-context";

interface InvoiceRowProps {
    obj: IInvoice;
}

function InvoiceRow({obj: initialObj}: InvoiceRowProps) {
    const {
        selectInvoice,
        isMonthlyInvoiceOverlayOpen,
        selectIsMonthlyInvoiceOverlayOpen, selectedYear, selectedPeriod,
    } = useAccounting()
    const {displayError, displayMessage} = useToast();
    const queryClient = useQueryClient();

    const putMutation = useApiUpdateRestaurateur();

    const [isLoading, setIsLoading] = useState(false);
    const [obj, setObj] = useState<IInvoice>(initialObj);
    const [ciscoId, setCiscoId] = useState<string | null | undefined>();


    const handleOpenMonthlyInvoice = (obj: IInvoice) => {
        selectIsMonthlyInvoiceOverlayOpen(!isMonthlyInvoiceOverlayOpen);
        !isMonthlyInvoiceOverlayOpen && selectInvoice(obj);
        isMonthlyInvoiceOverlayOpen && selectInvoice(undefined);
    };

    let labelStyle = "text-sm text-gray-500 font-bold mr-1";
    let contentStyle = "text-sm text-gray-800 font-bold mr-1";

    const csv_data = (invoice: IInvoice) => {
        const transformedData: Array<Record<string, any>> = [];
        const invoiceData = invoice_csv_data(invoice);
        invoiceData.forEach((record) => {
            record.year = selectedYear?.year;
            record.month = selectedPeriod?.month;
        });
        transformedData.push(...invoiceData);


        return transformedData;
    };

    const handleSubmit = async () => {

        try {
            setIsLoading(true);
            await putMutation.mutateAsync({
                restaurateur_id: obj.restaurateur.id,
                cisco_id: ciscoId || null,
            });
            displayMessage('CiscoId updated successfully');

        } catch (error) {
            const axiosError = error as CustomAxiosError;
            if (axiosError.response && axiosError.response.data && axiosError.response.data.message) {
                displayError(axiosError.response.data.message);
            } else {
                displayError('An error occurred while saving the CiscoId');
            }
        } finally {
            setIsLoading(false);
            await queryClient.invalidateQueries('getMonthlyInvoices');
        }
    };


    useEffect(() => {
        if (initialObj) {
            setObj(initialObj);
            setCiscoId(initialObj.restaurateur.cisco_id);
        }
    }, [initialObj])


    return (
        <>
            <div
                className='flex flex-row'
                style={{minWidth: 800}}
            >
                <div
                    className="relative flex flex-col w-fit gap-2 cursor-pointer bg-gray-200 shadow-xl rounded-lg px-4 py-2 mb-2 mt-2"
                >

                    <CSVLink
                        title='Esporta Dati in CSV'
                        data={csv_data(obj)}
                        headers={csvHeaders}
                        filename="exported-data.csv"
                        separator=";"
                        className="absolute top-2 right-2 p-2 rounded-full bg-mcia_salmon text-white hover:bg-mcia_orange cursor-pointer"
                        target="_blank"
                    >
                        <PiFileCsv/>
                    </CSVLink>
                    <button
                        title='Dettaglio Fatture'
                        onClick={() => handleOpenMonthlyInvoice(obj)}
                        className='absolute top-2 right-12 p-2 rounded-full bg-mcia_salmon text-white hover:bg-mcia_orange cursor-pointer'>
                        <LiaFileInvoiceDollarSolid
                            color={(obj.restaurateur.monthly_invoices.length > 0) ? 'green' : 'red'}
                        /></button>
                    <div>
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Ristoratore: </label>
                            <label className={contentStyle}>{obj.restaurateur.name}</label>
                        </div>
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Vat: </label>
                            <label className={contentStyle}>{obj.restaurateur.vat_number}</label>
                        </div>
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Email: </label>
                            <label className={contentStyle}>{obj.restaurateur.email}</label>
                        </div>
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Codice Studio Cisco: </label>
                            <input
                                type="text"
                                value={ciscoId ? ciscoId : undefined}
                                onChange={(e) => setCiscoId(e.target.value)}
                                onBlur={handleSubmit}
                                className="px-3 border rounded-md bg-mcia_gray_soft ml-1 "
                            />
                        </div>
                        <div className="flex flex-grow">
                            <label className={'cisco_label'}>Imponibile da Fatturare: </label>
                            <label
                                className={'cisco_label font-bold'}>{obj.restaurateur.total_to_invoice.toFixed(2)}</label>
                        </div>
                        <div className="flex flex-grow">
                            <label className={labelStyle}>Imponibile Fatturato: </label>
                            <label className={contentStyle}>{obj.restaurateur.total_invoiced}</label>
                        </div>
                    </div>
                    <div className="flex flex-col ml-0 w-[600px]">
                        <RestaurantsList obj={obj.restaurateur}/>
                    </div>
                </div>

            </div>

        </>
    );
}

export default InvoiceRow;
